import { Loader } from "@googlemaps/js-api-loader";

class ActivityMap extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const loader = new Loader({
      apiKey: "AIzaSyD6EEiz70Ka7PFjczl2GSZspZukvuHPJaw",
      version: "weekly",
    });

    loader.load().then(async () => {
      const { Map } = await google.maps.importLibrary("maps");

      let map = new Map(document.getElementById("map"), {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
      });
    });
  }

  disconnectedCallback() {}
}

customElements.define("nabohjaelp-activity-map", ActivityMap);
